@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/the-woods-post-card-stack-content/the-woods-properties-section/the-woods-properties-section.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
.the-woods-properties {
  width: 100%;
  display: grid;
  grid-template-columns: 2.5rem 0.5rem fit-content(4.375rem) 1.25rem 2.5rem 0.5rem fit-content(4.375rem);
  height: 4rem;
  overflow-y: clip;
}
.the-woods-properties .property-name {
  font-family: "alternate-gothic-no-3-d", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 111.111%;
  letter-spacing: 0.0225rem;
  height: 1.33rem;
}
.the-woods-properties .property-value {
  font-family: "alternate-gothic-no-3-d", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 111.111%;
  letter-spacing: 0.0225rem;
  height: 1.33rem;
  align-content: center;
  justify-self: end;
  overflow-x: hidden;
  white-space: nowrap;
}
/*# sourceMappingURL=the-woods-properties-section.component.css.map */
